import styled from 'styled-components';

export const SurveysCont = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 100vh;
  overflow: auto;
  width: 100%;
  position: relative;
`;

export const SurveysTableCont = styled.div`
  width: 100%;
  height: 100vh;
  padding-top: 56px;
`;
